// extracted by mini-css-extract-plugin
export default {"container":"Watchlater_container__9Nj2s","list-container":"Watchlater_list-container__LIg9L"};